module.exports = __webpack_public_path__ + "static/media/challenge-5.5d4d9e8f.png";